import { FC } from 'react'

import clsx from 'clsx'

import MbankLogo from 'shared/icons/payment-method/mbank-logo.svg'
import MInstalmentIcon from 'shared/icons/payment-method/minstallment-circle.svg'
import MplusLogoWhite from 'shared/icons/payment-method/mplus-logo-white.svg'
import MplusLogo from 'shared/icons/payment-method/mplus-logo.svg'

import s from './styles.module.scss'

type Variant =
  | 'mbank'
  | 'mplus'
  | 'mplusActive'
  | 'mplusInactive'
  | 'minstallment'

interface Props {
  variant: Variant
}

const logos: Record<Exclude<Variant, 'minstallment'>, string> = {
  mbank: MbankLogo,
  mplus: MplusLogo,
  mplusActive: MplusLogoWhite,
  mplusInactive: MplusLogoWhite,
}

export const PaymentIcon: FC<Props> = ({ variant }) => {
  if (variant === 'minstallment') {
    return (
      <img
        src={MInstalmentIcon}
        alt=""
        className={s.icon}
      />
    )
  }

  return (
    <div className={clsx(s.icon, s[variant])}>
      <img
        src={logos[variant]}
        alt=""
        className={s.logo}
      />
    </div>
  )
}
